import i18n from "i18next";
import {ButtonSecondary} from "@/Components/Buttons/ButtonSecondary";
import {useState} from "react";
import {Inertia} from "@inertiajs/inertia";
import Chip from "@/Components/Chip";
import {ButtonPrimary} from "@/Components/Buttons/ButtonPrimary";
import {usePage} from "@inertiajs/inertia-react";
import {navigateToURL} from "@/Utilities/Util";

export default function Module({module, isOrgModule, statusName, dispatch}) {

    const [disableStartTrial, setDisableStartTrial] = useState(false);
    const features = usePage().props.features;
    const salesloftURL = usePage().props.salesloft_url;
    const lcStatusName = statusName?.toLowerCase();
    const isActive = (lcStatusName === 'active');
    const isProvisioning = (lcStatusName === 'provisioning');

    function startTrial() {
        Inertia.post(
            route('organization.add-modules.store'),
            {modules: [module.uuid]}
        );
    }

    let manageModuleDivTestId = lcStatusName;

    if (isOrgModule){
        if (module.trial && features['trials']){
            if (module.trial.days_remaining > 0){
                manageModuleDivTestId = 'trial_active';
            } else {
                manageModuleDivTestId = 'trial_expired';
            }
        }
    } else {
        manageModuleDivTestId = 'not_active';
    }

    const OpenButton = (props) => {
        return (
            <ButtonSecondary
                disabled={props.disabled ?? false}
                onClick={() => window.location.href = module.access_url}
            >
                {i18n.t("subscriptions.open")}
            </ButtonSecondary>
        )
    }

    const ActivateButton = () => {
        return (
            <ButtonSecondary
                onClick={() => {
                    setDisableStartTrial(true);
                    startTrial();
                }}
                disabled={disableStartTrial}
            >
                {i18n.t("subscriptions.activate")}
            </ButtonSecondary>
        )
    }

    const SubscribeButton = () => {
        return (
            <ButtonPrimary
                onClick={() => {
                    !salesloftURL ?
                        dispatch({
                            type: "showCheckoutModal",
                            payload: {showCheckoutModal: true}
                        }) : navigateToURL(salesloftURL)
                }}
            >{i18n.t("subscriptions.subscribe")}</ButtonPrimary>
        )
    }

    const ManageButton = () => {
        return (
            <ButtonSecondary onClick={() => {
                !salesloftURL ?
                    dispatch({
                        type: "showCheckoutModal",
                        payload: {showCheckoutModal: true}
                    }) : navigateToURL(salesloftURL)
            }}>
                {i18n.t("subscriptions.manage")}
            </ButtonSecondary>
        )
    }

    const UpgradeButton = () => {
        return (
            <ButtonPrimary onClick={() => {
                !salesloftURL ?
                    dispatch({
                        type: "showCheckoutModal",
                        payload: {showCheckoutModal: true}
                    }) : navigateToURL(salesloftURL)
            }}>
                {i18n.t("subscriptions.upgrade")}
            </ButtonPrimary>
        )
    }

    function ActionButtons() {
        // Plan type is defined
        if (module.plan_type) {
            if (module.plan_type !== 'Free') {
                return (
                    <>
                        <ManageButton/>
                        <OpenButton/>
                    </>
                );
            } else {
                return (<>
                        <UpgradeButton/>
                        <OpenButton/>
                    </>
                );
            }
        }

        // Module is not part of organisation
        if (!isOrgModule) {
            if (module.canTrial && features['trials']) {
                return <ActivateButton/>;
            } else if (features['checkout'] && features['trials']) {
                return <SubscribeButton/>;
            } else {
                return <></>;
            }
        }

        // provisioning module to be with disabled open button
        if (isProvisioning) {
            return <OpenButton disabled={true}/>;
        }

        // Module is part of organisation
        return (
            <>
                {((module.trial && features['checkout'] && features['trials']) || !isActive)
                    && <SubscribeButton/>}
                {((!module.trial && isActive) || (module.trial && module.trial.days_remaining >0)) && <OpenButton/>}
            </>);
    }

    function getTranslation(lcStatusName) {
         return i18n.t("subscriptions." + lcStatusName);
    }

    return (
        <div className="module" data-testid={"manage_module-div-"+manageModuleDivTestId}>
            <span className="module-svg" style={{
                backgroundColor: module.colors.color ? module.colors.color : "black"
            }} dangerouslySetInnerHTML={{__html: module.icon}}/>
            <span className="module-title-and-desc" data-testid="manage_module-span-title_and_desc">
                <span className="module-title">{module.sales_name ?? module.name}</span>
                <span className="module-description">{module.description}</span>
            </span>

            {
                module.plan_type &&
                <span className="module-plan-type-container">
                     <span className="plan-type-heading">Subscription</span>
                    <span className="plan-type">{module.plan_type}</span>
                </span>
            }

            <span className="active-container">
                <span className="active-tag-button">
                    {/* Status chip */}
                    {(() => {
                        if (module.trial) {
                            return (
                                module.trial.days_remaining > 0 && features['trials'] ?
                                    <Chip dataTestid="manage_module-chip-subscription_trial_active"
                                          label={i18n.t("subscriptions.trial-active")} color="trial-active"/> :
                                    <Chip dataTestid="manage_module-chip-subscription_trial_expired"
                                          label={i18n.t("subscriptions.trial-expired")} color="trial-expired"/>
                            )
                        }
                        if (!isOrgModule) {
                            return (
                                <Chip dataTestid="manage_module-chip-subscription_not_active"
                                      label={i18n.t("subscriptions.not-active")} color="not-org-module"/>
                            )
                        }

                        return (
                            <Chip dataTestid={"manage_module-chip-subscription_" + lcStatusName}
                                  label={getTranslation(lcStatusName)}
                                  color={lcStatusName}
                            />
                        )
                    })()}

                    <span className="action-buttons">
                        <ActionButtons/>
                    </span>
                </span>
            </span>
        </div>
)
}
